import { ProcessCategory } from 'types/processesTypes';
import { Product } from 'types/productsTypes';

type Type = {
  id: string;
  name: string;
  products: Product[];
};

type Commodity = {
  id: string;
  name: string;
  types: Type[];
};

type DataItem = {
  id: string;
  name: string;
  commodities?: Commodity[];
  types?: Type[];
};

export function extractProductNames(data: DataItem[]): string[] {
  const productNames: string[] = [];

  const extractFromLevel = (items: (Commodity | Type)[]) => {
    items.forEach(item => {
      if ('products' in item) {
        item.products.forEach(product => {
          productNames.push(product.name);
        });
      } else if ('types' in item) {
        extractFromLevel(item.types);
      }
    });
  };

  data.forEach(item => {
    if (item.commodities) {
      extractFromLevel(item.commodities);
    } else if (item.types) {
      extractFromLevel(item.types);
    }
  });

  return productNames;
}

export function extractProcessNames(data: ProcessCategory[]): string[] {
  const processNames: string[] = [];

  data.forEach(category => {
    category.processes.forEach(process => {
      processNames.push(process.name);
    });
  });

  return processNames;
}

export function generateRandomAddress(): string {
  const hexCharacters = '0123456789ABCDEF';
  let address = '0x';

  for (let i = 0; i < 40; i++) {
    const randomChar =
      hexCharacters[Math.floor(Math.random() * hexCharacters.length)];
    address += randomChar;

    if (Math.random() > 0.5) {
      address = address.slice(0, -1) + address.slice(-1).toLowerCase();
    }
  }

  return address;
}
